import React from "react";
import { TrainingTopic } from "../../types/TrainingTopic";
import { makeStyles } from "@material-ui/core";
import TrainingListTopic from "./TrainingListTopic";

interface IProps {
  topics: TrainingTopic[];
  isSubList: boolean;
  onTopicClick: (topic: TrainingTopic) => void;
  selectedTopicId: string;
}

export default function TrainingList(props: IProps) {
  const { topics, isSubList, onTopicClick, selectedTopicId } = props;
  const classes = useStyles();

  return (
    <div className={classes.container}>
      {topics &&
        topics.map((topic, index) => (
          <TrainingListTopic
            topic={topic}
            showSmall={isSubList}
            index={index}
            key={index}
            selectedTopicId={selectedTopicId}
            onClick={onTopicClick}
          />
        ))}
      {!isSubList ? <div className="v-line"></div> : null}
    </div>
  );
}

const useStyles = makeStyles(theme => ({
  container: {
    position: "relative"
  }
}));
